var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function moveItemByDelta(array, selfIndex, indexDelta) {
    var nextIndex = selfIndex + indexDelta;
    if (0 <= selfIndex && selfIndex < array.length && 0 <= nextIndex && nextIndex < array.length) {
        var arr = __spreadArray([], __read(array), false);
        var indexes = [selfIndex, nextIndex].sort(function (a, b) { return a - b; });
        arr.splice(indexes[0], 2, arr[indexes[1]], arr[indexes[0]]);
        return arr;
    }
    else {
        return array;
    }
}
export function moveItemToPrev(array, selfIndex) {
    return moveItemByDelta(array, selfIndex, -1);
}
export function moveItemToNext(array, selfIndex) {
    return moveItemByDelta(array, selfIndex, 1);
}
export function removeItem(array, omitCondition) {
    var omitKeys = Object.keys(omitCondition);
    return array.filter(function (item) { return omitKeys.filter(function (omit) { return item[omit] !== omitCondition[omit]; }).length > 0; });
}
export function insertItem(array, value, index) {
    if (index <= -array.length) {
        return __spreadArray([value], __read(array), false);
    }
    else if (index >= array.length) {
        return __spreadArray(__spreadArray([], __read(array), false), [value], false);
    }
    else {
        return __spreadArray(__spreadArray(__spreadArray([], __read(array.slice(0, index)), false), [value], false), __read(array.slice(index)), false);
    }
}
//# sourceMappingURL=arrayList.js.map